export const PopperModifiers = {
  setWidth: {
    enabled: true,
    order: 840,
    fn(data: any, options: any) {
      const { innerWidth } = window;
      const { isInitialized = false } = data.instance;
      const { initialWidth = 0 } = data.instance;

      if (!isInitialized) {
        data.instance.initialWidth = data.offsets.popper.width;
      }

      /**
       * Prevent overflow
       */

      if (data.offsets.popper.width > innerWidth) {
        data.offsets.popper.width = data.styles.width = data.offsets.reference.width;
        data.offsets.popper.left = data.styles.left = 0;
        data.offsets.popper.right = data.styles.right = 0;

        /**
         * Min Popper width should be referce width
         */
      } else if (data.offsets.reference.width > initialWidth) {
        data.offsets.popper.left = data.styles.left = data.offsets.reference.left;

        data.offsets.popper.right = data.styles.right = data.offsets.reference.right;

        data.offsets.popper.width = data.styles.width = Math.round(data.offsets.reference.width);
        /**
         * Max Popper width should be it's contents width
         */
      } else if (
        isInitialized &&
        (data.offsets.popper.width > data.offsets.reference.width || data.offsets.popper.width < initialWidth)
      ) {
        data.offsets.popper.left = 0;
        data.offsets.popper.right = 0;
        data.offsets.popper.width = data.styles.width = initialWidth;
        data.styles.left = Math.round((data.offsets.reference.width - data.offsets.popper.width) / 2);
        data.offsets.popper.right = data.styles.right = data.styles.left;
      }

      data.instance.isInitialized = true;

      return data;
    }
  }
};
